import axiosInstance from "../axiosConfig";
import { APIResponse, PaymentData } from "./paymentsService.types";

import { logger } from "utils/logger";

export interface PaymentListFilters {
  studentIds?: string[];
}

export const fetchPayments = async (
  page: number = 1,
  pageSize: number = 7,
  ordering: string = "",
  filters: PaymentListFilters = {},
): Promise<APIResponse<PaymentData>> => {
  const url = `/courses/payments-list/`;
  try {
    const response = await axiosInstance.get(url, {
      params: {
        page,
        page_size: pageSize,
        ordering,
        student_ids: filters.studentIds?.length ? filters.studentIds.join(",") : undefined,
      },
    });
    return response.data;
  } catch (error) {
    logger.error("Ошибка при получении списка платежей:", error);
    throw error;
  }
};
